export function MediaCardSkeleton() {
  return (
    <div className="animate-pulse overflow-hidden rounded-3xl border border-neutral-100 bg-white shadow-sm">
      <div className="aspect-video bg-neutral-200" />
      <div className="space-y-3 p-5">
        <div className="h-5 w-4/5 rounded bg-neutral-200" />
        <div className="h-4 w-full rounded bg-neutral-100" />
        <div className="h-4 w-2/3 rounded bg-neutral-100" />
      </div>
    </div>
  )
}
